export const CLASSES = {
  active: 'is-active',
  scrolling: 'is-scrolled',
  noTouch: 'no-touch',
  hide: 'is-hidden',
  overflow: 'is-overflow',
  focus: 'is-focus',
  fixed: 'is-fixed',
  statical: 'is-static',
  filled: 'is-filled'
};

export const DOM = {
  $window: $(window),
  $body: $('body'),
  $document: $('document'),
  $header: $('.js-header'),
  $burger: $('.js-burger'),
  $menu: $('.js-menu'),
  $claimText: $('.js-claim-text'),
  $claim: $('.claim'),
};

export const BREAKPOINTS = {
  sm: 719,
  md: 959
};
